import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import { ThemeProvider } from "./design-system";

/**
 * The portal's real theme, built from Aoife's delivered FRP tokens
 * (`design-system/tokens.ts`, ADR-20260917-m51n). This replaces the
 * milestone 1 scaffold's placeholder `shellTheme` (ADR-20260821-swpq) —
 * the theming feature owns the portal's design tokens, per that theme's
 * own comment. `design-system/` is the only module in the repository
 * that may import `@mui/*` (AC-1); this file consumes it only through
 * `ThemeProvider`.
 */
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error('index.html is missing the "#root" mount element');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
